import { React, useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import IconButton from "@mui/material/IconButton";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";
import { Dropdown } from "semantic-ui-react";
import Tooltip from "@mui/material/Tooltip";
import { Stack } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import Papa from "papaparse";
import MDBadge from "components/MDBadge";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DescriptionIcon from "@mui/icons-material/Description";
import VisibilityIcon from "@mui/icons-material/Visibility";
import colors from "assets/theme/base/colors";
import "../campus/Campus.css"
import nodata from "assets/images/nodata.png";
const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

function SelectedApplications() {
  // Variable Declarations
  const [applications, setApplications] = useState([]);
  const [all_campaigns, setAllCampaigns] = useState([]);
  const [campaign_id, setCampaignId] = useState("");
  const [filter, setFilter] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("");

  //Dialog Settings
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [anchorEl, setAnchorEl] = useState(null);
  const [opens, setOpens] = useState(false);
  const [currentAppId, setCurrentAppId] = useState(null);

  const handleClick = (event, appId) => {
    setAnchorEl(event.currentTarget);
    setOpens(true);
    setCurrentAppId(appId);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpens(false);
    setCurrentAppId(null);
  };

  const handleViewApplication = (id) => {
    window.open(`/view-application/${currentAppId}`);
  };

  // Session Storage handling
  var user = JSON.parse(sessionStorage.getItem("user"));
  if (user) {
    var organization_id = user.organization_id;
  } else {
    var organization_id = null;
  }

  // Rows & Columns Injection
  const columns = [
    { Header: "Sr.No", accessor: "serial", align: "center" },
    { Header: "Applicant ID", accessor: "applicant_id", align: "left" },
    { Header: "First Name", accessor: "first_name", align: "left" },
    { Header: "Last Name", accessor: "last_name", align: "center" },
    { Header: "Father Name", accessor: "father_name", align: "center" },
    { Header: "Gender", accessor: "gender", align: "center" },
    { Header: "DOB", accessor: "dob", align: "center" },
    { Header: "City", accessor: "city", align: "center" },
    { Header: "Country", accessor: "country", align: "center" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Actions", accessor: "actions", align: "center" },
  ];

  const rows =
    applications.length > 0
      ? applications.map((app, index) => ({
          serial: index + 1,
          applicant_id: app.id,
          first_name: app.first_name,
          last_name: app.last_name,
          father_name: app.father_name,
          gender: app.gender,
          dob: app.dob,
          city: app.c_city,
          country: app.c_country,
          status: (
            <MDBox ml={-1}>
              <MDBadge
                badgeContent="Selected"
                color="success"
                variant="gradient"
                size="sm"
              />
            </MDBox>
          ),
          actions: (
            <>
              <div>
                <IconButton
                  aria-label="more"
                  id={`long-button-${index}`}
                  aria-controls={opens ? "long-menu" : undefined}
                  aria-expanded={opens ? "true" : undefined}
                  aria-haspopup="true"
                  onClick={(event) => handleClick(event, app.id)}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id="long-menu"
                  anchorEl={anchorEl}
                  open={opens}
                  onClose={handleClose}
                >
                  <MenuItem onClick={handleViewApplication}>
                    <VisibilityIcon
                      style={{ marginRight: "15px", color: "blue" }}
                    />{" "}
                    View & Verify Application
                  </MenuItem>
                </Menu>
              </div>
            </>
          ),
        }))
      : [
          {
            serial: null,
            first_name: null,
            last_name: null,
            father_name: null,
            gender: null,
            dob: null,
            city: null,
            country: null,
            status: null,
            actions: null,
          },
        ];
  const handleExportCSV = () => {
    const data = [
      columns.map((col) => col.Header),
      ...rows.map((row) => Object.values(row)),
    ];

    const csv = Papa.unparse(data);

    const blob = new Blob([csv], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "Applications.csv";

    link.click();
  };

  const handleCampaignType = (value) => {
    setCampaignId(value);
    getApplications(value);
  };

  const handleSearchKeywordChange = (e) => {
    const searchTerm = e.target.value.trim().toLowerCase();
    setSearchKeyword(searchTerm);

    if (searchTerm === "") {
      getApplications(campaign_id);
    } else {
      let filteredApplications = applications.filter((app) => {
        const idMatch = app.id && app.id.toString().includes(searchTerm);
        const firstNameMatch =
          app.first_name && app.first_name.toLowerCase().includes(searchTerm);
        const lastNameMatch =
          app.last_name && app.last_name.toLowerCase().includes(searchTerm);
        const fatherNameMatch =
          app.father_name && app.father_name.toLowerCase().includes(searchTerm);
        const genderMatch =
          app.gender && app.gender.toLowerCase().includes(searchTerm);
        const dobMatch = app.dob && app.dob.toLowerCase().includes(searchTerm);
        const cityMatch =
          app.c_city && app.c_city.toLowerCase().includes(searchTerm);
        const countryMatch =
          app.c_country && app.c_country.toLowerCase().includes(searchTerm);

        return (
          idMatch ||
          firstNameMatch ||
          lastNameMatch ||
          fatherNameMatch ||
          genderMatch ||
          dobMatch ||
          cityMatch ||
          countryMatch
        );
      });

      setApplications(filteredApplications);
    }
  };

  // GET Api calls
  const getAllCampaigns = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    };
    await fetch(BASE_URL + `/campaign/get_campaigns`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setAllCampaigns(data.campaigns);
      })
      .catch((error) => console.log(error));
  };

  const getApplications = async (id) => {
    let data = { campaign_id: id };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(data),
    };
    await fetch(
      `${BASE_URL}/application/get_selected_applications_by_campaign`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setApplications(data.applications);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    getAllCampaigns();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <div className="d-flex align-items-end justify-content-between">
              <div className="col-md-3">
                <label>Campaign</label>
                <Dropdown
                  id="campaign_id"
                  name="campaign_id"
                  placeholder="Select Campaign Type"
                  fluid
                  selection
                  value={campaign_id}
                  onChange={(e, { value }) => handleCampaignType(value)}
                  options={all_campaigns.map((camp) => ({
                    key: camp.id,
                    text: camp.name,
                    value: camp.id,
                  }))}
                />
              </div>
            </div>

            <Card
              className="mt-5 card1"
             
            >
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                variant="gradient"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  spacing={1}
                  sx={{ width: "100%" }}
                >
                  <Stack sx={{ flexGrow: 1 }}>
                    <Paper
                      component="form"
                      className="search-paper"
                    >
                      <InputBase
                        sx={{ ml: 1, flex: 1, fontSize: "16px" }}
                        placeholder="Search"
                        inputProps={{ "aria-label": "search voucher" }}
                        value={searchKeyword}
                        onChange={handleSearchKeywordChange}
                      />
                      <SearchIcon
                        className="search-icon"
                      />
                    </Paper>
                  </Stack>
                  <Button
                    variant="outlined"
                    endIcon={
                      <DescriptionIcon
                       className="add-icon"
                      />
                    }
                    onClick={() => {
                      handleExportCSV();
                    }}
                    className="add-full-button"
                  >
                    Export CSV
                  </Button>
                </Stack>
              </MDBox>
              <MDBox pt={3}>
                {applications && applications.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <img
                      src={nodata}
                      style={{
                        display: "block",
                        margin: "auto",
                        width: "20%",
                        height: "20%",
                      }}
                    />
                  </div>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default SelectedApplications;
